<div class="card kpi-green">
    <div class="card-body kpi-card">
        <h5 class="card-title">Total des loyers</h5>
        <p class="card-value">
            <ng-container *ngIf="preview">- €</ng-container>
            <ng-container *ngIf="!preview">
                {{ favorite.amount_rent | number: '1.0-0' }} €
            </ng-container>
        </p>
    </div>
</div>
